import React from 'react'



import { ModalLayout } from './components/modal'
import { Img } from '../../components/img'
import { Button } from './components/button'

import './css/styles.css'
import { FirstBlock } from './components/first-block'
import { SecondBlock } from './components/second-block'
import { RulesBlock } from './components/rules-block'


export const Main=()=>{
    return(
        <div className='main bg_fire'>
            <ModalLayout/>
            <div className='content mt-4'>
                <div className='main-layaout m-4'>
                    <FirstBlock/>
                    <SecondBlock/>
                    <RulesBlock/>
                </div>
            </div>
        </div>
        
    )
}